import styled from 'styled-components';

const FooterContainer = styled.div`
    width: 100%;
    background-color: white;

    display: flex;
    justify-content: center;

    padding: 20px;
    font-size: 0.8rem;
    text-align: center;
    color: ${props => props.theme.footerTheme.copyrightTextColor};
`;

export default FooterContainer;
